// Terms of Service Page
export function TermsOfServicePage() {
  return `
<div class="min-h-screen bg-gray-50">
    <div class="hero">
        <div class="hero-content">
            <h1 class="hero-title">Terms of Service</h1>
            <p class="hero-subtitle">General conditions for the use of our services</p>
        </div>
    </div>

    <section class="section bg-gray-50">
        <div class="container">
            <div class="max-w-4xl mx-auto prose prose-lg">
                <div class="bg-white p-8 rounded-lg shadow-sm">
                    <h2 class="text-2xl font-bold text-gray-900 mb-6">Terms of Service</h2>
                    
                    <div class="space-y-6 text-gray-700">
                        <h2 class="text-2xl font-bold text-gray-900 mb-6">General Conditions – Clients (Spain)</h2>
                        
                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Article 1 – Definitions</h3>
                        <ul class="space-y-3">
                            <li><strong>Offer:</strong> the set of products and services of the Advisor (Energy Performance Certificate) that the Client can contract through the Platform.</li>
                            <li><strong>Mediation / Service:</strong> the commercial intermediation services provided by Epcspainhomes España S.L. to facilitate the conclusion of a contract between Client and Advisor.</li>
                            <li><strong>Platform:</strong> the website, tools, and other digital channels of Epcspainhomes España S.L. where the Service is offered.</li>
                            <li><strong>Advisor:</strong> technician or company recognized in Spain and authorized to prepare and register an Energy Performance Certificate with the competent authority of the autonomous community.</li>
                            <li><strong>Client:</strong> any natural or legal person who places an Order through the Platform.</li>
                            <li><strong>Energy Performance Certificate (EPC):</strong> the official certificate indicating the energy performance of a property, mandatory in sales or rentals according to Royal Decree 390/2021.</li>
                            <li><strong>Contract / Order:</strong> the agreement between the Client and the Advisor for the preparation of the EPC.</li>
                            <li><strong>CeeCasasEspana España S.L.:</strong> the intermediary entity providing the Service, based in Spain and operating under the name EPCSpainHomes.com.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Article 2 – Identity of EPCSpainHomes.com</h3>
                        <p>Epcspainhomes España S.L.<br>
                        Address: Av. de Andalucia, 21, 29679 Benahavís, Málaga<br>
                        Registered in the Madrid Mercantile Registry with number [to be indicated].<br>
                        CIF: [to be indicated].<br>
                        E-mail: info@epcspainhomes.com</p>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Article 3 – Applicability</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>These General Conditions apply to the Service provided by EPCSpainHomes.com.</li>
                            <li>EPCSpainHomes.com is not responsible for the content of the Offer nor for the execution of the Order, which is the sole and exclusive responsibility of the Advisor.</li>
                            <li>By placing an Order through the Platform, the Client enters into a contract directly with the Advisor.</li>
                            <li>The cancellation of the Order can be made within 14 calendar days according to the General Law for the Defense of Consumers and Users (Royal Legislative Decree 1/2007), unless the service has already been provided.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Article 4 – Offer</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>EPCSpainHomes.com publishes the Offer on behalf of the Advisors based on the information provided by them.</li>
                            <li>Although the information is prepared with the utmost diligence, EPCSpainHomes.com is not responsible for errors or inaccuracies in the Offer or in the Advisor's data.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Article 5 – Conclusion of the Contract</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>The Contract is concluded when the Client confirms the Order through the Platform.</li>
                            <li>The Client is responsible for providing correct and complete data for the preparation of the EPC.</li>
                            <li>Payment is made through the Platform or directly to the Advisor. EPCSpainHomes.com may be authorized by the Advisor to manage payments.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Article 6 – Cancellation and termination</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>The Client may cancel the Order within 14 days after its confirmation, unless the service has already been performed.</li>
                            <li>If the Advisor cannot execute the Order due to force majeure or incorrect data, the Contract may be terminated without the right to compensation.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Article 7 – Payment</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>All prices are expressed in euros and include VAT.</li>
                            <li>Payment is made in advance by a secure payment method.</li>
                            <li>The invoice will be issued by the Advisor or on their behalf by EPCSpainHomes.com.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Article 8 – Claims</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>Claims regarding the execution of the Order must be addressed directly to the Advisor.</li>
                            <li>Claims regarding the Service of EPCSpainHomes.com can be sent by email to info@epcspainhomes.com.</li>
                            <li>EPCSpainHomes.com will confirm receipt within 7 days and will try to respond within a maximum of 14 days.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Article 9 – Newsletter and reviews</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>The Client may voluntarily subscribe to the newsletter and unsubscribe at any time.</li>
                            <li>After completing the Order, the Client may leave a review that will be visible on the Platform.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Article 10 – Data protection</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>Personal data will be processed in accordance with Regulation (EU) 2016/679 (GDPR) and Organic Law 3/2018 (LOPDGDD).</li>
                            <li>The privacy policy is available at www.epcspainhomes.com.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Article 11 – Intellectual property</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>All texts, designs, logos, and other content of the Platform are the property of EPCSpainHomes.com.</li>
                            <li>It is prohibited to copy, modify, or publish any content without prior written authorization.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Article 12 – Applicable law and jurisdiction</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>These General Conditions are governed exclusively by Spanish law.</li>
                            <li>Any dispute will be submitted to the competent courts of Madrid, unless otherwise provided by law.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Contact</h3>
                        <p>For questions related to these terms of service:</p>
                        <p><strong>E-mail:</strong> info@epcspainhomes.com</p>
                        <p><strong>Phone:</strong> 626 80 65 52</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

    `;
}
